// Vocabulaire du dialog anti-doublon, DÉRIVÉ (pur, testable, sans React) :
//  - `mode`   pilote la FORME des cartes ("client" | "dossier").
//  - `entity` SURCHARGE le vocabulaire indépendamment de la forme des cartes.
// Profil installateur/OMV : client = dossier (1:1) → on parle de "dossier" sur
// des cartes de forme "client" (les candidats viennent de la dédup client).
// TEF/AMO (entity absent) → vocabulaire "client" inchangé. Aucun slug en dur :
// l'appelant passe `entity` dérivé du profil métier (anti fail-to-TEF).
export function duplicateDialogLexicon({ mode = "client", entity } = {}) {
  const isDossierCards = mode === "dossier";
  const speaksDossier = (entity || (isDossierCards ? "dossier" : "client")) === "dossier";

  if (isDossierCards) {
    return {
      speaksDossier: true,
      title: "Un dossier existe déjà pour ce client",
      description:
        "Un ou plusieurs dossiers sont déjà rattachés à ce client. Vous pouvez ouvrir un dossier existant plutôt que d'en créer un nouveau.",
      createLabel: "Créer un nouveau dossier",
      useLabel: "Ouvrir le dossier existant",
      showCancel: false,
    };
  }
  if (speaksDossier) {
    return {
      speaksDossier: true,
      title: "Ce dossier existe déjà",
      description:
        "Un ou plusieurs dossiers correspondent à la saisie. Ouvrez le dossier existant pour éviter les doublons, ou créez-en un nouveau en cas d'homonymie légitime.",
      createLabel: "Créer le dossier",
      useLabel: "Utiliser le dossier",
      showCancel: true,
    };
  }
  return {
    speaksDossier: false,
    title: "Ce client existe déjà",
    description:
      "Un ou plusieurs clients correspondent à la saisie. Choisissez un client existant pour éviter les doublons, ou créez un nouveau client en cas d'homonymie légitime.",
    createLabel: "Créer un nouveau client",
    useLabel: "Utiliser ce client",
    showCancel: false,
  };
}
